<template>
  <div :class="CategoryData && [0, 1, 2].includes(CategoryData.Category.Type) ? 'awards' : 'festival'"
    v-if="CategoryData">
    <HeadBlock />

    <!-- 毛毛蟲 -->
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <div class="container">
          <li class="breadcrumb-item"><router-link to="/" :title="$t('首頁')">{{ $t('首頁') }}</router-link></li>
          <li class="breadcrumb-item active" aria-current="page" v-if="[0, 1, 2].includes(CategoryData.Category.Type)">
            {{ $t('金曲獎') }}</li>
          <li class="breadcrumb-item active" aria-current="page" v-else>{{ $t('金曲國際音樂節') }}</li>
          <li class="breadcrumb-item active" aria-current="page">{{ CategoryData.Category.CategoryName }}</li>
        </div>
      </ol>
    </nav>
    <a accesskey="c" id="accesskey_c" href="#" title="中間主要內容區">
      :::
    </a>

    <!-- 金曲獎-一般列表 -->
    <div class="main newsList" v-if="CategoryData.Category.Type == 0">
      <div class="container">
        <div class="title">
          <h2>{{ CategoryData.Category.CategoryName }}</h2>
        </div>
        <ul class="list">
          <li class="" v-for="Post in Posts" :key="Post.PId">
            <a :href="gotoPostLink(Post)" :target="Post.Type == 1 && Post.Blank ? '_blank' : ''"
              :title="Post.Title + (Post.Type == 1 && Post.Blank ? ', 另開新視窗' : '')">
              <p class="time">
                {{ Post.PublicStartTime | timeString("YYYY-MM-DD") }}
              </p>
              <p class="title">
                {{ Post.Title }}
              </p>
            </a>
          </li>
        </ul>
        <ul class="page_box">
          <li class="prev" :class="pageNow - 1 < 1 ? 'disabled' : ''">
            <a title="上一頁" href="javascript:void(0)"
              @click="pageNow - 1 >= 1 ? loadList(pageNow - 1) : loadList(pageNow)">&lt;</a>
          </li>
          <!-- 第一頁 -->
          <li class="page" :class="pageNow == 1 ? 'active' : ''">
            <a title="第 1 頁" href="javascript:void(0)" @click="loadList(1)">1</a>
          </li>
          <!-- 左側省略號 -->
          <li class="page disabled" v-if="startPage > 2">
            <a class="">…</a>
          </li>
          <!-- 中間頁面 -->
          <li class="page" :class="index === pageNow ? 'active' : ''" v-for="index in visiblePages" :key="index">
            <a :title="'第 ' + index + ' 頁'" href="javascript:void(0)" @click="loadList(index)">{{ index }}</a>
          </li>
          <!-- 右側省略號 -->
          <li class="page disabled" v-if="endPage < pageAll - 1">
            <a class="">…</a>
          </li>
          <!-- 最後一頁 -->
          <li class="page" :class="pageNow == pageAll ? 'active' : ''" v-if="pageAll > 1">
            <a :title="'第 ' + pageAll + ' 頁'" href="javascript:void(0)" @click="loadList(pageAll)">{{ pageAll }}</a>
          </li>
          <li class="next" :class="pageNow + 1 > pageAll ? 'disabled' : ''">
            <a tabindex="0" title="下一頁" href="javascript:void(0)"
              @click="pageNow + 1 <= pageAll ? loadList(pageNow + 1) : loadList(pageNow)">&gt;</a>
          </li>
        </ul>
      </div>
    </div>

    <!-- 金曲獎-歷屆得獎名單 -->
    <div class="main shortList previousAwards" v-if="CategoryData.Category.Type == 1">
      <div class="container">
        <div class="title">
          <h2>{{ CategoryData.Category.CategoryName }}</h2>
        </div>
        <div class="box">
          <div class="tabs">
            <ul class="btn_box">
              <li v-for="(ordinalTab, ordinalIndex) in CategoryData.ordinalTabs" :key="ordinalIndex">
                <button :class="['category_btn', { active: selectedTab_1 === ordinalIndex }]"
                  @click="selectTab_1(ordinalIndex)" :aria-selected="selectedTab_1 == ordinalIndex ? 'true' : 'false'">
                  {{ ordinalTab.ordinal }}
                </button>
              </li>
            </ul>
          </div>
          <div class="content">
            <div class="" v-html="CategoryData.ordinalTabs[selectedTab_1].texts">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 金曲獎-圖文列表 -->
    <div class="main pictureList" v-if="CategoryData.Category.Type == 2">
      <div class="container">
        <div class="title">
          <h2>{{ CategoryData.Category.CategoryName }}</h2>
        </div>
        <ul class="list row" v-if="CategoryData.Category.Type == 2">
          <li class="col-12 col-md-6 col-lg-4 " v-for="Post in Posts" :key="Post.PId">
            <a :href="gotoPostLink(Post)" :target="Post.Type == 1 && Post.Blank ? '_blank' : ''"
              :title="Post.Title + (Post.Type == 1 && Post.Blank ? ', 另開新視窗' : '')" style="width: 100%;">
              <div class="img_box">
                <img :src="CategoryData.SiteUrl + Post.Image" :alt="Post.Title">
              </div>
              <p class="title">
                {{ Post.Title }}
              </p>
            </a>
          </li>
        </ul>
        <ul class="page_box">
          <li class="prev" :class="pageNow - 1 < 1 ? 'disabled' : ''">
            <a title="上一頁" href="javascript:void(0)"
              @click="pageNow - 1 >= 1 ? loadList(pageNow - 1) : loadList(pageNow)">&lt;</a>
          </li>
          <!-- 第一頁 -->
          <li class="page" :class="pageNow == 1 ? 'active' : ''">
            <a title="第 1 頁" href="javascript:void(0)" @click="loadList(1)">1</a>
          </li>
          <!-- 左側省略號 -->
          <li class="page disabled" v-if="startPage > 2">
            <a class="">…</a>
          </li>
          <!-- 中間頁面 -->
          <li class="page" :class="index === pageNow ? 'active' : ''" v-for="index in visiblePages" :key="index">
            <a :title="'第 ' + index + ' 頁'" href="javascript:void(0)" @click="loadList(index)">{{ index }}</a>
          </li>
          <!-- 右側省略號 -->
          <li class="page disabled" v-if="endPage < pageAll - 1">
            <a class="">…</a>
          </li>
          <!-- 最後一頁 -->
          <li class="page" :class="pageNow == pageAll ? 'active' : ''" v-if="pageAll > 1">
            <a :title="'第 ' + pageAll + ' 頁'" href="javascript:void(0)" @click="loadList(pageAll)">{{ pageAll }}</a>
          </li>
          <li class="next" :class="pageNow + 1 > pageAll ? 'disabled' : ''">
            <a tabindex="0" title="下一頁" href="javascript:void(0)"
              @click="pageNow + 1 <= pageAll ? loadList(pageNow + 1) : loadList(pageNow)">&gt;</a>
          </li>
        </ul>
      </div>
    </div>

    <!-- 音樂節-活動日程表 -->
    <div class="main festivalschedule" v-if="CategoryData.Category.Type == 3">
      <div class="container">
        <div class="title_text">
          <!-- logo圖 -->
          <div class="img_box">
            <!-- <img :src="CategoryData.SiteLogo" alt="GMA logo" v-if="CategoryData.SiteLogo"> -->
            <img src="img/GMAlogo.svg" alt="GMA logo" v-if="CategoryData.SiteLogo">
            <img src="img/GMAlogo.svg" alt="GMA logo" v-else>
          </div>
          <div class="text_box">
            <div class="title">
              <h2>{{ CategoryData.Category.CategoryName }}</h2>
            </div>
            <div class="text" v-html="CategoryData.Category.Description">
            </div>
          </div>
        </div>
        <div class="box">
          <div class="tabs">
            <ul class="btn_box">
              <li v-for="(tab, index) in CategoryData.dateTabs" :key="index">
                <button :class="['festival_btn', { active: selectedTab_3 === index }]" @click="selectTab_3(index)">
                  <p>{{ tab.btn }}</p>
                </button>
              </li>
            </ul>
          </div>
          <div class="content">
            <div v-for="(text, index) in CategoryData.dateTabs[selectedTab_3].texts" :key="index">
              <img :src="text.src" :alt="text.alt">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 音樂節-音樂專題/媒合會 -->
    <div class="main festivalConference" v-if="CategoryData.Category.Type == 4">
      <div class="container">
        <div class="title_text">
          <!-- logo圖 -->
          <div class="img_box">
            <!-- <img :src="CategoryData.SiteLogo" alt="GMA logo" v-if="CategoryData.SiteLogo"> -->
            <img src="img/GMAlogo.svg" alt="GMA logo" v-if="CategoryData.SiteLogo">
            <img src="img/GMAlogo.svg" alt="GMA logo" v-else>
          </div>
          <div class="text_box">
            <div class="title">
              <h2>{{ CategoryData.Category.CategoryName }}</h2>
            </div>
            <div class="text" v-html="CategoryData.Category.Description">
            </div>
          </div>
        </div>
        <div class="box">
          <!-- Tab切換部分 -->
          <div class="tabs">
            <ul class="btn_box">
              <li v-for="(tab, index) in CategoryData.tabs" :key="index">
                <button :class="['festival_btn', { active: selectedTab_4 === index }]" @click="selectTab_4(index)"
                  :aria-selected="selectedTab_4 == index ? 'true' : 'false'"
                  :aria-expanded="selectedTab_4 == index ? 'true' : 'false'">
                  {{ tab.btn }}
                </button>
              </li>
            </ul>
          </div>
          <div class="content">
            <div v-show="selectedTab_4 === index" v-for="(tab, index) in CategoryData.tabs" :key="index">
              <template v-if="tab.type == 1">
                <div class="tabs">
                  <ul class="btn_box sub_tab">
                    <li v-for="(Post, index_sub) in CategoryData.tabs[index].contents" :key="index_sub">
                      <button :class="['festival_btn', { active: selectedSubTab_4 === index_sub }]"
                        @click="selectSubTab_4(index_sub)"
                        :aria-selected="selectedSubTab_4 == index_sub ? 'true' : 'false'"
                        :aria-expanded="selectedSubTab_4 == index_sub ? 'true' : 'false'">
                        {{ Post.Title }}
                      </button>
                    </li>
                  </ul>
                </div>
                <div class="number_theme" v-for="(Post, index_sub) in CategoryData.tabs[index].contents"
                  :key="index_sub" v-if="selectedSubTab_4 == index_sub">
                  <div v-if="Post.Content" v-html="Post.Content">
                  </div>
                </div>
              </template>
              <template v-if="tab.type == 2 && tab.content">
                <div v-html="tab.content">
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 音樂節-SHOWCASE -->
    <div class="main festivalPictureList festivalPictureList_2" v-if="CategoryData.Category.Type == 10">
      <div class="container">
        <div class="title_text">
          <div class="img_box">
            <!-- <img :src="CategoryData.SiteLogo" alt="GMA logo" v-if="CategoryData.SiteLogo"> -->
            <img src="img/GMAlogo.svg" alt="GMA logo" v-if="CategoryData.SiteLogo">
            <img src="img/GMAlogo.svg" alt="GMA logo" v-else>
          </div>
          <div class="text_box">
            <div class="title">
              <h2>{{ CategoryData.Category.CategoryName }}</h2>
            </div>
            <div class="text" v-html="CategoryData.Category.Description">
            </div>
          </div>
        </div>
        <div class="box">
          <div class="tabs">
            <ul class="btn_box">
              <li v-for="(tab, index) in CategoryData.tabs" :key="index">
                <button :class="['festival_btn', { active: selectedTab_10 === index }]" @click="selectTab_10(index)"
                  :aria-selected="selectedTab_10 == index ? 'true' : 'false'"
                  :aria-expanded="selectedTab_10 == index ? 'true' : 'false'">
                  {{ tab.btn }}
                </button>
              </li>
            </ul>
          </div>
          <div class="content"
            v-if="CategoryData.tabs[selectedTab_10].type == 1 && CategoryData.tabs[selectedTab_10].list && CategoryData.tabs[selectedTab_10].list.length > 0">
            <div class="text_img none_bg">
              <div v-for="(itemList, index) in CategoryData.tabs[selectedTab_10].list" :key="index">
                <div class="title_box">
                  <h2>{{ itemList.title }} <span class="time">{{ itemList.time }}</span></h2>
                </div>
                <ul class="list">
                  <li class="" v-for="(item, index) in itemList.imgList" :key="index">
                    <a :href="gotoPostLink(item.to)" :target="item.to.Type == 1 && item.to.Blank ? '_blank' : ''"
                      :title="item.to.Title + (item.to.Type == 1 && item.to.Blank ? ', 另開新視窗' : '')">
                      <div class="img_box">
                        <img :src="item.src" :alt="item.to.Title">
                      </div>
                      <p>{{ item.to.Title }}</p>
                    </a>
                    <hr class="line">
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="content"
            v-if="CategoryData.tabs[selectedTab_10].type == 2 && CategoryData.tabs[selectedTab_10].content"
            v-html="CategoryData.tabs[selectedTab_10].content">
          </div>
        </div>
      </div>
    </div>

    <!-- 音樂節-金曲星聲代 -->
    <div class="main festivalPictureList" v-if="CategoryData.Category.Type == 5">
      <div class="container">
        <div class="title_text">
          <div class="img_box">
            <!-- <img :src="CategoryData.SiteLogo" alt="GMA logo" v-if="CategoryData.SiteLogo"> -->
            <img src="img/GMAlogo.svg" alt="GMA logo" v-if="CategoryData.SiteLogo">
            <img src="img/GMAlogo.svg" alt="GMA logo" v-else>
          </div>
          <div class="text_box">
            <div class="title">
              <h2>{{ CategoryData.Category.CategoryName }}</h2>
            </div>
            <div class="text" v-html="CategoryData.Category.Description">
            </div>
          </div>
        </div>
        <div class="box">
          <div class="content">
            <div class="text_img" v-for="SubCategory in CategoryData.SubCategorys" :key="SubCategory.CId">
              <div class="title_box">
                <h2>{{ SubCategory.Title }} <span class="time">{{ SubCategory.SubTitle }}</span></h2>
              </div>
              <ul class="list row">
                <li class="col-12 col-md-6 col-lg-4" v-for="Post in SubCategory.Posts" :key="Post.PId">
                  <a :href="gotoPostLink(Post)" :target="Post.Type == 1 && Post.Blank ? '_blank' : ''"
                    :title="Post.Title + (Post.Type == 1 && Post.Blank ? ', 另開新視窗' : '')">
                    <div class="img_box">
                      <img :src="CategoryData.SiteUrl + Post.Image" :alt="Post.Title">
                    </div>
                    <p>{{ Post.Title }}</p>
                  </a>
                </li>
              </ul>
              <hr class="line">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 音樂節-場地資訊 -->
    <div class="main festivalPlace" v-if="CategoryData.Category.Type == 7">
      <div class="container">
        <div class="title_text">
          <div class="img_box">
            <!-- <img :src="CategoryData.SiteLogo" alt="GMA logo" v-if="CategoryData.SiteLogo"> -->
            <img src="img/GMAlogo.svg" alt="GMA logo" v-if="CategoryData.SiteLogo">
            <img src="img/GMAlogo.svg" alt="GMA logo" v-else>
          </div>
          <div class="text_box">
            <div class="title">
              <h2>{{ CategoryData.Category.CategoryName }}</h2>
            </div>
            <div class="text" v-html="CategoryData.Category.Description">
            </div>
          </div>
        </div>
        <div class="box">
          <div class="tabs">
            <ul class="btn_box">
              <li v-for="(tab, index) in CategoryData.placeTabs" :key="index">
                <button :class="['festival_btn', { active: selectedTab_7 === index }]" @click="selectTab_7(index)"
                  :aria-expanded="selectedTab_7 == index ? 'true' : 'false'">
                  <p>{{ tab.btn }}</p>
                </button>
              </li>
            </ul>
          </div>
          <div class="content" v-if="CategoryData.placeTabs[selectedTab_7].texts"
            v-html="CategoryData.placeTabs[selectedTab_7].texts">
          </div>
        </div>
      </div>
    </div>

    <!-- 音樂節-策略聯盟 -->
    <div class="main festivalOther" v-if="CategoryData.Category.Type == 6">
      <div class="container">
        <div class="title_text">
          <div class="img_box">
            <!-- <img :src="CategoryData.SiteLogo" alt="GMA logo" v-if="CategoryData.SiteLogo"> -->
            <img src="img/GMAlogo.svg" alt="GMA logo" v-if="CategoryData.SiteLogo">
            <img src="img/GMAlogo.svg" alt="GMA logo" v-else>
          </div>
          <div class="text_box">
            <div class="title">
              <h2>{{ CategoryData.Category.CategoryName }}</h2>
            </div>
            <div class="text" v-html="CategoryData.Category.Description">
            </div>
          </div>
        </div>
        <div class="box">
          <div class="content">
            <div class="text_img" v-for="(text, index) in CategoryData.texts" :key="index">
              <div class="title_box">
                <h2>{{ text.title }}</h2>
                <p class="subtitle">{{ text.subContent }}</p>
              </div>
              <hr class="line">
              <div class="text_box row">
                <div class="col-12 col-lg-5">
                  <div class="carousel_box">
                    <div>
                      <VueSlickCarousel :arrows="false" :dots="true">
                        <div class="img_box" v-for="(carousel, carouselIndex) in text.carouselItems"
                          :key="carouselIndex">
                          <img :src="carousel.src" :alt="text.title + ' 照片 ' + (carouselIndex + 1)">
                        </div>
                      </VueSlickCarousel>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-7">
                  <div class="text" v-html="text.content">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <FooterBlock v-if="CategoryData && [0, 1, 2].includes(CategoryData.Category.Type)" />
    <FestivalFooterBlock v-else />
  </div>
</template>
<script>
import HeadBlock from "@/components/HeadBlock.vue";
import FooterBlock from "@/components/FooterBlock.vue";
import FestivalFooterBlock from "@/components/FestivalFooterBlock.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

const messages = {
  zh_tw: {
    "首頁": "首頁",
    "金曲獎": "金曲獎",
    "金曲國際音樂節": "金曲國際音樂節",
  },
  en: {
    "首頁": "Home",
    "金曲獎": "Golden Melody Awards",
    "金曲國際音樂節": "Golden Melody Festival",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

import Slick from "vue-slick";

export default {
  name: "Category",
  i18n,
  components: {
    Slick,
    HeadBlock,
    FooterBlock,
    FestivalFooterBlock,
    VueSlickCarousel,
  },
  data() {
    return {
      CategoryData: null,

      Keyword: "",
      Posts: null,
      pageAll: 0,
      perPage: 10,
      pageNow: 1,
      total: 0,
      maxVisiblePages: 5,

      selectedTab_1: 0,

      selectedTab_3: 0,

      selectedTab_4: 0,
      selectedSubTab_4: 0,

      selectedTab_10: 0,

      selectedTab_7: 0,

      local: "zh_tw",

      Posts_All: null,
    };
  },
  computed: {
    // 計算顯示範圍的起始頁
    startPage() {
      const half = Math.floor(this.maxVisiblePages / 2);
      return Math.max(2, this.pageNow - half); // 從第2頁開始
    },
    // 計算顯示範圍的結束頁
    endPage() {
      const half = Math.floor(this.maxVisiblePages / 2);
      return Math.min(this.pageAll - 1, this.pageNow + half); // 到倒數第2頁為止
    },
    // 中間可見頁面
    visiblePages() {
      const pages = [];
      for (let i = this.startPage; i <= this.endPage; i++) {
        pages.push(i);
      }
      return pages;
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.fetchCategoryData(to.params.CId);
    next();
  },
  created: function () {
    this.fetchCategoryData(this.$route.params.CId);
  },
  mounted: function () {
    if ($cookies.isKey("gma_the_site_lang")) {
      i18n.locale = $cookies.get("gma_the_site_lang");
      this.local = $cookies.get("gma_the_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }
  },
  updated: function () {
  },
  methods: {
    fetchCategoryData(CId) {
      // Vue.axios
      //   .get(
      //     this.$store.state.src +
      //     this.$store.state.subDirectory +
      //     "/Html/Category",
      //     {
      //       params: { CId: CId, lang: $cookies.get("gma_the_site_lang") },
      //     }
      //   )
      //   .then((response) => {
      //     this.CategoryData = response.data;
      //     this.Keyword = "";
      //     this.pageNow = -1;
      //     if (this.CategoryData.Category.Type == 0) {
      //       this.perPage = 5;
      //       this.loadList(1);
      //     } else if (this.CategoryData.Category.Type == 2) {
      //       this.perPage = 9;
      //       this.loadList(1);
      //     }
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });
      fetch("/gma/36th/data/category/all/" + CId + ".json")
        .then(response => response.json())
        .then(data => {
          this.CategoryData = data;
          fetch("/gma/36th/data/postlist/all/" + CId + ".json")
            .then(response_pl => response_pl.json())
            .then(data_pl => {
              this.Posts_All = data_pl;
              this.Keyword = "";
              this.pageNow = -1;
              if (this.CategoryData.Category.Type == 0) {
                this.perPage = 5;
                this.loadList(1);
              } else if (this.CategoryData.Category.Type == 2) {
                this.perPage = 9;
                this.loadList(1);
              }
            })
            .catch(error_pl => {
              console.error("載入JSON失敗：", error_pl);
            });
        })
        .catch(error => {
          console.error("載入JSON失敗：", error);
        });
    },
    loadList: function (page) {
      var that = this;
      if (that.pageNow == page) {
        return;
      }
      // $.ajax({
      //   url:
      //     this.$store.state.src +
      //     this.$store.state.subDirectory +
      //     "/Html/PostList",
      //   type: "post",
      //   data: {
      //     CId: that.CategoryData.Category.CId,
      //     Keyword: that.Keyword,
      //     page: page,
      //     perPage: that.perPage,
      //     lang: $cookies.get("gma_the_site_lang"),
      //   },
      //   dataType: "json",
      //   error: function () { },
      //   success: function (res) {
      //     if (res.status == 1) {
      //       that.total = res.total;
      //       that.pageNow = page;
      //       that.Posts = res.Posts;
      //       that.perPage = res.perPage;
      //       that.pageAll = Math.max(Math.ceil(res.total / that.perPage), 1);
      //       window.scrollTo({
      //         top: 0,
      //         behavior: 'smooth'
      //       });
      //     }
      //   },
      // });
      if (that.Posts_All.status == 1) {
        that.total = that.Posts_All.total;
        that.pageNow = page;
        that.Posts = that.Posts_All.Posts.slice((page - 1) * that.perPage, page * that.perPage);
        that.perPage = that.perPage;
        that.pageAll = Math.max(Math.ceil(that.Posts_All.total / that.perPage), 1);
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    },
    gotoPost(Post) {
      if (Post.Type == 1) {
        if (Post.Blank) {
          window.open(Post.Url, "_blank");
        } else {
          location.href = Post.Url;
        }
      } else {
        this.$router.push({
          name: "Post",
          params: { PId: Post.PId, CId: this.CategoryData.Category.CId },
        });
      }
    },
    gotoPostLink(Post) {
      if (Post.Type == 1) {
        if (Post.Url.startsWith("/")) {
          return this.CategoryData.SiteUrl + Post.Url;
        } else {
          return Post.Url;
        }
      } else {
        const routeData = this.$router.resolve({
          name: "Post",
          params: { PId: Post.PId/*, CId: this.FestivalHomeData.EventSeries_Category.CId*/ },
        });
        return routeData.href;
      }
    },
    // 切換頁籤
    selectTab_1(ordinalIndex) {
      this.selectedTab_1 = ordinalIndex;
    },
    selectTab_3(dateTabs) {
      this.selectedTab_3 = dateTabs;
    },
    selectTab_4(index) {
      this.selectedTab_4 = index;
      this.selectedSubTab_4 = 0;
    },
    selectSubTab_4(index) {
      this.selectedSubTab_4 = index;
    },
    selectTab_10(dateTabs) {
      this.selectedTab_10 = dateTabs;
    },
    selectTab_7(dateTabs) {
      this.selectedTab_7 = dateTabs;
    },
  },
};
</script>